module.exports = __webpack_public_path__ + "simquadrat-bottom-bw.svg?568d259721b3b7e45c9a55bd0af48b4b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/simquadrat-bottom-bw.svg
// module id = 79
// module chunks = 0